var _excluded = ["initOption", "options", "initGroupOption", "optionsGrouped", "onOptionSelected", "position", "variant", "defaultLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useEffect, useRef, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { Text } from '../Text';
import { IarrowUp, IarrowDown2 } from '../AgroIcon/icons';
import { Box } from '../Box';
var DropdownMenuWithHoc = withCssProps(function (_ref) {
  var _ref$initOption = _ref.initOption,
    initOption = _ref$initOption === void 0 ? 0 : _ref$initOption,
    options = _ref.options,
    _ref$initGroupOption = _ref.initGroupOption,
    initGroupOption = _ref$initGroupOption === void 0 ? {
      group: 0,
      option: 0
    } : _ref$initGroupOption,
    optionsGrouped = _ref.optionsGrouped,
    onOptionSelected = _ref.onOptionSelected,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'bottom-right' : _ref$position,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    defaultLabel = _ref.defaultLabel,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(options && !defaultLabel && options[initOption].label || optionsGrouped && optionsGrouped[initGroupOption.group].options[initGroupOption.option].label),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var _useState5 = useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    focusId = _useState6[0],
    setFocusId = _useState6[1];
  var wrapperRef = useRef(null);
  var iconSize = variant === 'default' ? '16px' : '24px';
  var handleChange = function handleChange(data) {
    if (onOptionSelected) {
      setValue(data.label);
      onOptionSelected(data);
      setIsOpen(false);
    } else {
      onChange(data);
    }
  };
  var handleKeyCode = function handleKeyCode(e) {
    var keyCode = e.key;
    e.stopPropagation();
    var up = function up() {
      var back = focusId === -1 ? -1 : focusId - 1;
      setFocusId(back);
      e.preventDefault();
    };
    var down = function down() {
      var next = options && focusId === options.length - 1 ? focusId : focusId + 1;
      setFocusId(next);
      e.preventDefault();
    };
    var enter = function enter() {
      isOpen && options && handleChange(options[focusId]);
      setIsOpen(true);
    };
    switch (keyCode) {
      case 'ArrowUp':
        return up();
      case 'ArrowDown':
        return down();
      case 'Enter':
        return enter();
      default:
        return null;
    }
  };
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);
  var getOptions = function getOptions() {
    var opt = [];
    var addOptions = function addOptions(item, idx) {
      opt.push( /*#__PURE__*/React.createElement(Option, {
        role: "button",
        type: "body-md",
        color: "black",
        onClick: function onClick() {
          return handleChange(item);
        },
        tabindex: "1",
        className: idx === focusId ? 'focus' : '',
        "aria-labelledby": "dropdown-label",
        key: idx,
        isGroup: optionsGrouped && optionsGrouped.length
      }, item.label));
    };
    if (options && options.length) {
      options.map(function (item, idx) {
        return addOptions(item, idx);
      });
    } else if (optionsGrouped && optionsGrouped.length) {
      optionsGrouped.forEach(function (item, idx) {
        opt.push( /*#__PURE__*/React.createElement(GroupTitle, {
          type: "body-md",
          color: "gray600",
          key: idx
        }, item.groupLabel));
        item.options.map(function (op, index) {
          return addOptions(op, "".concat(index, "-").concat(idx, "-").concat(item.groupLabel));
        });
      });
    }
    return opt;
  };
  return /*#__PURE__*/React.createElement(DropdownMenuContainer, _extends({
    ref: wrapperRef
  }, props), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    "align-items": "center"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyCode(e);
    },
    variant: variant
  }, defaultLabel ? defaultLabel : value, isOpen ? /*#__PURE__*/React.createElement(IarrowUp, {
    height: iconSize,
    width: iconSize,
    fill: variant === 'dark' ? 'gray800' : 'blue600',
    ml: variant = 'dark' && 'xxs'
  }) : /*#__PURE__*/React.createElement(IarrowDown2, {
    height: iconSize,
    width: iconSize,
    fill: variant === 'dark' ? 'gray800' : 'blue600',
    ml: variant = 'dark' && 'xxs'
  }))), (options && options.length || optionsGrouped && optionsGrouped.length) && /*#__PURE__*/React.createElement(OptionList, {
    isOpen: isOpen,
    isGroup: optionsGrouped && optionsGrouped.length,
    position: position,
    variant: variant
  }, getOptions()));
});
var AgroDropdownMenu = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(DropdownMenuWithHoc, _extends({
    inputRef: ref
  }, props));
});
AgroDropdownMenu.displayName = 'AgroDropdownButton';
export { AgroDropdownMenu };
var optionType = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.any
}));
AgroDropdownMenu.propTypes = {
  initOption: PropTypes.number,
  options: optionType,
  initGroupOption: PropTypes.shape({
    group: PropTypes.number,
    option: PropTypes.number
  }),
  optionsGrouped: PropTypes.arrayOf(PropTypes.shape({
    groupLabel: PropTypes.string,
    options: optionType
  })),
  onOptionSelected: PropTypes.func,
  ref: PropTypes.any,
  position: PropTypes.oneOf(['bottom-left', 'bottom-right']),
  variant: PropTypes.oneOf(['default', 'dark'])
};
var DropdownMenuContainer = styled.div.withConfig({
  displayName: "AgroDropdownMenu__DropdownMenuContainer",
  componentId: "sc-17pc952-0"
})(["position:relative;"]);
var Dropdown = styled.button.withConfig({
  displayName: "AgroDropdownMenu__Dropdown",
  componentId: "sc-17pc952-1"
})(["all:unset;cursor:pointer;font-family:", ";color:", ";font-size:14px;font-weight:500;line-height:32px;letter-spacing:-0.2px;display:flex;align-items:center;&:hover,&:focus,&:active{color:", ";}", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blue600;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.blue900;
}, function (_ref5) {
  var variant = _ref5.variant;
  return variant === 'dark' && css(["color:", ";&:hover{color:", ";}&:focus,&:active{color:", ";}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.gray800;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.gray900;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.black;
  });
});
var OptionList = styled.ul.withConfig({
  displayName: "AgroDropdownMenu__OptionList",
  componentId: "sc-17pc952-2"
})(["display:", ";list-style:none;background:#ffffff;box-sizing:border-box;box-shadow:0px 3px 6px rgba(0,0,0,0.07);border-radius:12px;padding:", ";margin:0;width:max-content;max-height:186px;overflow-x:hidden;overflow-y:auto;z-index:5;position:absolute;", " ", " ", "::-webkit-scrollbar{width:18px;background-color:transparent;}::-webkit-scrollbar-track{border:none;background-color:transparent;}::-webkit-scrollbar-thumb{height:6px;border:6px solid transparent;border-radius:100px;background-color:", ";background-clip:content-box;}@media (min-width:", "){", "}"], function (_ref9) {
  var isOpen = _ref9.isOpen;
  return isOpen ? 'block' : 'none';
}, function (_ref10) {
  var isGroup = _ref10.isGroup;
  return isGroup ? '16px 0px' : '12px 0px';
}, function (_ref11) {
  var variant = _ref11.variant;
  return variant === 'default' && css(["border:1px solid ", ";"], function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.gray400;
  });
}, function (_ref13) {
  var position = _ref13.position;
  return position === 'bottom-right' && css(["right:0;"]);
}, function (_ref14) {
  var position = _ref14.position;
  return position === 'bottom-left' && css(["left:0;"]);
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.gray500;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.breakpoint.md;
}, function (_ref17) {
  var variant = _ref17.variant;
  return variant === 'default' && css(["min-width:270px;"]);
});
var Option = styled(Text).withConfig({
  displayName: "AgroDropdownMenu__Option",
  componentId: "sc-17pc952-3"
})(["display:flex;align-items:center;padding:", ";cursor:pointer;&.focus,&.selected{background-color:", ";}&:hover:not(.selected){background-color:", ";}"], function (_ref18) {
  var isGroup = _ref18.isGroup;
  return isGroup ? '10px 32px' : '10px 16px';
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.gray300;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.gray200;
});
var GroupTitle = styled(Text).withConfig({
  displayName: "AgroDropdownMenu__GroupTitle",
  componentId: "sc-17pc952-4"
})(["padding:0px 16px;"]);